/**
 * Matches one `{{…}}` token of a communication template. Group 1 is the token name with the whitespace inside the
 * braces trimmed, so `{{ name }}` and `{{name}}` resolve to the same variable on the server and in the web UI.
 * Global: use it with `matchAll` and `replace` only, never `test` or `exec`, which would keep `lastIndex` state.
 */
export const templateVariablePattern = /{{\s*(.*?)\s*}}/g
